import { ApiService } from "@/api";

export const updateMemberNote = (sampleId: string, memberNote: string) => {
  console.log('mmmeemmber', memberNote)
  return ApiService.baseAction(
    `sample-detail/member_note/${sampleId}`,
    {
      data: {
        memberNote,
      },
    },
    "post"
  );
};
